'use client';

import { useEffect } from 'react';
import type { UserProfileDto } from '@unreserved/sdk';
import { setSdkDeviceId } from '@unreserved/services/sdk-client';
import { useAuthStore } from '@/stores/auth-store';
import { DEVICE_ID_KEY } from '@unreserved/constants/notifications';

type AuthProviderProps = {
  initialUser: UserProfileDto | null;
  children: React.ReactNode;
};

export function AuthProvider({ initialUser, children }: AuthProviderProps) {
  const setUser = useAuthStore((state) => state.setUser);
  const clearUser = useAuthStore((state) => state.clearUser);

  useEffect(() => {
    if (initialUser) {
      setUser(initialUser);
    } else {
      clearUser();
    }
  }, [initialUser, setUser, clearUser]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const deviceId = localStorage.getItem(DEVICE_ID_KEY);
      setSdkDeviceId(deviceId);
    }
  }, []);

  return <>{children}</>;
}
